/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { getAllSubscriptionWithCurrent } from "@/services/subscriptionsApi";
import { useEffect, useState } from "react";

const buttonColors = [
  "btn-primary",
  "btn-secondary",
  "btn-success",
  "btn-warning",
  "btn-info",
  "btn-dark",
];

const formatNumber = (num: number) => {
  if (num >= 1000000) return (num / 1000000).toFixed(0) + "M";
  if (num >= 1000) return (num / 1000).toFixed(0) + "K";
  return num;
};

const SubscriptionsPage = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const userId = user?.id;

  const [plans, setPlans] = useState([]);
  const [currentPlanId, setCurrentPlanId] = useState(null);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [scheduledPlan, setScheduledPlan] = useState(null);
  const [expiryDate, setExpiryDate] = useState(null);
  const [duration, setDuration] = useState("yearly"); // default
  const [loading, setLoading] = useState(true);

  // Fetch API Data
  const fetchPlans = async () => {
    setLoading(true);
    const response = await getAllSubscriptionWithCurrent(userId, duration);

    // console.log(response);
    const currentPlanData = response.value.currentPlan || null;
    if (response?.value) {
      setPlans(response.value.plans || []);
      setScheduledPlan(response.value.schedule_plan || null);
      setCurrentPlanId(response.value.currentPlanId || null);
      setCurrentPlan(response.value.currentPlan || null);

      if (currentPlanData?.end_date) {
        const date = new Date(currentPlanData.end_date);
        const formatted = date.toLocaleDateString("en-GB");
        setExpiryDate(formatted);
      } else {
        setExpiryDate(null); // or "" if you prefer
      }
    }

    setLoading(false);
  };

  useEffect(() => {
    if (userId) fetchPlans();
  }, [duration, userId]);

  // TOGGLE SWITCH FIX
  const handleToggle = (e) => {
    setDuration(e.target.checked ? "yearly" : "monthly");
  };

  const verifyWithRetry = async (response, retries = 3) => {
    try {
      await verifyPayment(response);
    } catch (err) {
      if (retries > 0) {
        setTimeout(() => verifyWithRetry(response, retries - 1), 3000);
      }
    }
  };

  const verifyPayment = (response: any) => {
    console.log();
  };

  const checkout = (plan) => {
    localStorage.setItem("checkout_plan", JSON.stringify(plan));
    navigate("/checkout");
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="social-dash-wrap">
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb-main justify-content-lg-start card align-content-start p-2">
                <div className="align-content-center align-items-center card-body d-flex justify-content-between p-0 p-2 w-100">
                  <div className="">
                    <h3 className="text-xl mt-0.5 fw-600">
                      {/* <span className="text-primary text-xl"> */}
                      My Subscriptions
                    </h3>
                  </div>

                  <div className="breadcrumb-action justify-content-center flex-wrap">
                    <div className="action-btn m-0">
                      <div className="flex items-center gap-4">
                        <div className="action-btn"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="about-projects p-0 p-2 w-100">
                  <ul className="d-flex text-capitalize mt-0 pt-0">
                    <li className="align-center block flex gap-3 my-0">
                      <span className="color-light fs-13">Plan name :</span>
                      <p className="color-dark fs-16 mt-1 mb-0 fw-500">
                        {currentPlan?.name}
                      </p>
                    </li>

                    <li className="align-center block flex gap-3 my-0">
                      <span className="color-light fs-13">Expires On :</span>
                      <p className="color-danger fs-16 mt-1 mb-0 fw-500">
                        {expiryDate}
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white pt-50 pb-40 mb-30 px-xxl-0 px-30 shadow-lg rounded-xl">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <ul className="ai-list mb-40 mt-20">
                  <li className="ai-list-item">
                    <span
                      className={`monthly space-nowrap ${
                        duration === "monthly" ? "active" : ""
                      }`}
                    >
                      Billed Monthly
                    </span>
                  </li>

                  <li className="ai-list-item">
                    <input
                      className="ail ail-light"
                      id="ai1"
                      type="checkbox"
                      name="intervaltype"
                      onChange={handleToggle}
                      checked={duration === "yearly"}
                    />
                    <label
                      className="ail-btn"
                      htmlFor="ai1"
                      data-target="#monthly"
                    ></label>
                  </li>

                  <li className="ai-list-item">
                    <span
                      className={`yearly space-nowrap ${
                        duration === "yearly" ? "active" : ""
                      }`}
                    >
                      Billed Annually
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            {/* LOADING */}
            {loading && (
              <div className="spin-container d-flex justify-content-center">
                <div className="atbd-spin-dots spin-sm">
                  <span className="spin-dot badge-dot dot-primary"></span>
                  <span className="spin-dot badge-dot dot-primary"></span>
                  <span className="spin-dot badge-dot dot-primary"></span>
                  <span className="spin-dot badge-dot dot-primary"></span>
                </div>
              </div>
            )}

            {/* PLAN CARDS */}
            {!loading && (
              <div className="row pr-5 pl-5">
                {plans.map((plan, index) => (
                  <div
                    className="col-xxl-3 col-lg-4 col-sm-6 mb-30"
                    key={plan._id}
                  >
                    <div
                      className={`card h-100 ${
                        plan._id === currentPlanId ? "current-plan-card" : ""
                      }`}
                    >
                      <div className="card-body p-30">
                        <div className="pricing d-flex align-items-center">
                          <span className="pricing__tag color-dark order-bg-opacity-dark rounded-pill">
                            {plan.name}
                          </span>
                        </div>
                        <div className="pricing__price rounded">
                          {plan.pricing === 0 ? (
                            <div
                              style={{
                                minHeight: "80px", // match discounted plans height
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <p className="pricing_value display-3 color-dark fw-600 mb-1">
                                Free
                              </p>
                            </div>
                          ) : (
                            <>
                              {plan.discount_percentage > 0 && (
                                <div className="mt-2">
                                  <span
                                    style={{
                                      textDecoration: "line-through",
                                      color: "#8c98b4",
                                      marginRight: "8px",
                                    }}
                                  >
                                    ₹{plan.price_before_discount}
                                  </span>

                                  <span
                                    style={{
                                      color: "#20c997",
                                      fontWeight: 600,
                                    }}
                                  >
                                    Save {plan.discount_percentage}%
                                  </span>
                                </div>
                              )}

                              <p className="pricing_value display-3 color-dark d-flex align-items-center fw-600 mb-1">
                                <sup>₹</sup>
                                {plan.pricing}
                                <small className="pricing_user">
                                  {plan.duration === "monthly"
                                    ? " Per Month"
                                    : " Per Year"}
                                </small>
                              </p>
                            </>
                          )}
                        </div>

                        {/* Features */}
                        <div className="pricing__features">
                          <ul>
                            <li>
                              <span className="fa fa-check"></span>
                              {plan.projectLimit} Projects
                            </li>
                            <li>
                              <span className="fa fa-check"></span>
                              {plan.qrLimit} QR Codes
                            </li>
                            <li>
                              <span className="fa fa-check"></span>
                              {formatNumber(plan.scanLimitPerQr)} Scans per QR
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* BUTTON */}
                      <div className="price_action d-flex pb-30 pl-30">
                        {plan._id === currentPlanId ? (
                          <div className=" ">
                            <button className="btn btn-light btn-squared btn-outline-light text-capitalize px-30 color-gray fw-500">
                              Current Plan
                            </button>
                          </div>
                        ) : scheduledPlan && plan._id === scheduledPlan?._id ? (
                          <button
                            className={`btn btn-light     btn-squared text-capitalize px-30 fw-500`}
                            onClick={() => {}}
                          >
                            scheduled Plan
                          </button>
                        ) : (
                          <button
                            className={`btn btn-primary     btn-squared text-capitalize px-30 fw-500`}
                            onClick={() => checkout(plan)}
                          >
                            Change Plan
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionsPage;
